import {
  collectRoutines,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import { tap } from 'rxjs';
import { isShiftXUrl, urlUtils } from '@ardoq/common-helpers';
import { urlClicked } from '@ardoq/graph';
import { trackUrlLinkClicked } from './tracking';

const openClickedUrl = routine(
  ofType(urlClicked),
  extractPayload(),
  tap(({ url, viewId }) => {
    window.open(
      urlUtils.maybeRelativeUrl(url, isShiftXUrl(url)),
      '_blank',
      'noopener,noreferrer'
    );
    trackUrlLinkClicked(viewId);
  })
);

export const urlClickedRoutines = collectRoutines(openClickedUrl);
